/**
 * Custom pagination dots for the redemption widget's mobile Swiper carousel.
 *
 * Confirmed via live DOM: Yotpo's own carousel already renders a
 * `.swiper-pagination` container, but it never gets populated with
 * `.swiper-pagination-bullet` children — a bug on Yotpo's own side, not
 * something our CSS is hiding (see rewards-redeem.liquid, which hides that
 * empty container outright). Rather than depend on Yotpo fixing it, this
 * builds an independent set of dots from the real Swiper markup.
 *
 * Yotpo replaces the class list of the div we mount the widget into (same
 * pattern as every other Yotpo widget on this page) and mounts
 * asynchronously, so this watches the stable outer .rewards-redeem wrapper
 * (never touched by Yotpo) rather than the widget div itself, re-syncing on
 * every mutation until the carousel appears — and again on every slide
 * change, since Swiper tracks the active slide via a class
 * (.swiper-slide-active), not a one-time event.
 *
 * Only the mobile carousel (.yotpo-redemption-mobile-carousel) uses Swiper
 * at all — the desktop grid layout has no .swiper-wrapper in its markup, so
 * this naturally finds nothing and no-ops there without needing a
 * width/breakpoint check in JS. The dots' own CSS still gates visibility to
 * mobile widths as a defensive backstop.
 */
(function () {
  function getRealSlides(wrapper) {
    return Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide')).filter(function (slide) {
      return !slide.classList.contains('swiper-slide-duplicate');
    });
  }

  function goToSlide(wrapper, index) {
    var swiperEl = wrapper.closest('.swiper-container');
    if (swiperEl && swiperEl.swiper && typeof swiperEl.swiper.slideTo === 'function') {
      swiperEl.swiper.slideTo(index);
    }
  }

  function buildDots(root, wrapper, slides) {
    var existing = root.querySelector('.rewards-redeem__dots');
    if (existing) existing.remove();

    var dots = document.createElement('div');
    dots.className = 'rewards-redeem__dots';

    slides.forEach(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rewards-redeem__dot';
      dot.setAttribute('aria-label', 'Go to reward ' + (index + 1));
      dot.addEventListener('click', function () {
        goToSlide(wrapper, index);
      });
      dots.appendChild(dot);
    });

    var swiperContainer = wrapper.closest('.swiper-container');
    (swiperContainer || wrapper).insertAdjacentElement('afterend', dots);
    return dots;
  }

  function sync(root) {
    var wrapper = root.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var slides = getRealSlides(wrapper);
    if (!slides.length) return;

    var dots = root.querySelector('.rewards-redeem__dots');
    if (!dots || dots.children.length !== slides.length) {
      dots = buildDots(root, wrapper, slides);
    }

    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('swiper-slide-active');
    });

    Array.prototype.forEach.call(dots.children, function (dot, index) {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  document.querySelectorAll('.rewards-redeem').forEach(function (root) {
    sync(root);

    var observer = new MutationObserver(function () {
      sync(root);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  });
})();
